$('.amazon-review-list').slick({
  slidesToShow: 3,
  variableWidth: false,
  dots: false,
  autoplay: true,
  prevArrow: `
    <div class="left-arrow">
      <img src="//theideaspace.io/cdn/shop/t/41/assets/right-arrow.png?v=76568320805242524811767474547" alt="Previous">
    </div>
  `,
  nextArrow: `
    <div class="right-arrow">
      <img src="//theideaspace.io/cdn/shop/t/41/assets/right-arrow.png?v=76568320805242524811767474547" alt="Next">
    </div>
  `,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '25px', // Reduce side gap on mobile
        variableWidth: false,
        arrows: true,
      }
    }
  ]
});
document.addEventListener("DOMContentLoaded", function () {

    const modal = document.getElementById("reviewModal");

    if (!modal) return;

    const modalImage = modal.querySelector(".modal-image");
    const modalTitle = modal.querySelector(".modal-title");
    const modalStars = modal.querySelector(".modal-stars");
    const modalContent = modal.querySelector(".modal-content");
    const modalAvatar = modal.querySelector(".modal-avatar");
    const modalName = modal.querySelector(".modal-name");
    const modalVerified = modal.querySelector(".modal-verified");
    const modalDate = modal.querySelector(".modal-date");

    function openModal(card){

        // IMAGE
        const image = card.querySelector("[data-image] img");

        if(image){
            modalImage.innerHTML = image.outerHTML;
            modalImage.style.display = "";
        }else{
            modalImage.innerHTML = "";
            modalImage.style.display = "none";
        }

        modalTitle.innerHTML =
            card.querySelector("[data-title]")?.innerHTML || "";

        modalStars.innerHTML =
            card.querySelector("[data-stars]")?.innerHTML || "";

        modalContent.innerHTML =
            card.querySelector("[data-content]")?.innerHTML || "";

        modalAvatar.innerHTML =
            card.querySelector("[data-avatar]")?.innerHTML || "";

        modalName.innerHTML =
            card.querySelector("[data-name]")?.innerHTML || "";

        const verified = card.querySelector("[data-verified]");

        if(verified){
            modalVerified.innerHTML = verified.innerHTML;
            modalVerified.style.display = "";
        }else{
            modalVerified.innerHTML = "";
            modalVerified.style.display = "none";
        }

        modalDate.innerHTML =
            card.querySelector("[data-date]")?.innerHTML || "";

        modal.classList.add("active");

        document.body.classList.add("review-modal-open");
    }

    function closeModal(){

        modal.classList.remove("active");

        document.body.classList.remove("review-modal-open");

    }

    document.querySelectorAll(".amazon-review-card").forEach(function(card){

        card.addEventListener("click", function(){

            openModal(card);

        });

    });

    modal.querySelector(".review-modal__close").addEventListener("click", closeModal);

    modal.addEventListener("click", function(e){

        if(e.target === modal){
            closeModal();
        }

    });

    document.addEventListener("keydown", function(e){

        if(e.key === "Escape"){
            closeModal();
        }

    });

});